module.exports = __webpack_public_path__ + "static/media/logAltitudeActive.7f0c6cf0.svg";